module.exports = __webpack_public_path__ + "img/img31.0ba8fc02.svg";